import { render, staticRenderFns } from "./LogsDashboard.vue?vue&type=template&id=359a08d8"
import script from "./LogsDashboard.vue?vue&type=script&lang=js"
export * from "./LogsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports